import styled from "@emotion/styled";
import { FunctionComponent, ReactNode } from "react";

interface Props {
  className?: string;
  onClick?: () => void;
  children: ReactNode;
}

const ButtonComponent: FunctionComponent<Props> = (props) => {
  return (
    <div className={props.className} onClick={props.onClick}>
      {props.children}
    </div>
  );
};

export default styled(ButtonComponent)`
  font-weight: bold;
  color: #ccc;
  display: inline;
  height: auto;
  margin: 0;
  padding: 0;
  background: none;
  border: none;
`;
